﻿import api from '../api';

import {
  IDragInDropMinutaItemClausula,
  IEmCustomizacaoMinuta,
  IGerarMinuta,
  IGerarMinutaDocx,
  IMinuta,
  IMinutaClausula,
  IMinutaFilter,
  IMinutaItemClausulaCreate,
  IMinutaItemClausulaCreateByItemAprovado,
  IMinutaSimplificado,
  IMinutaVariavelItemClausula,
  IStatusMinuta,
} from '../../models/MinutaModels';

import { downloadAnexo } from '../apiAnexo';

export const getByIdMinuta = (id: string) => api.get<IMinuta>('minutas/' + id);
export const getAllMinuta = () => api.get<IMinuta[]>('minutas');
export const getAllMinutaSimplificado = () => api.get<IMinutaSimplificado[]>('minutas/getAllSimplificado');

export const getAllStatusMinuta = () => api.get<IStatusMinuta[]>('minutas/status');

export const getAllStatusMinutaOptions = () =>
  getAllStatusMinuta().then(data => (data || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const getMinutasbyFilter = (values: IMinutaFilter) => {
  return api.post<IMinutaSimplificado[]>('minutas/filter', values, { disableNotification: true });
};

export const postMinuta = (values: IEmCustomizacaoMinuta) => {
  return api.post<IMinutaVariavelItemClausula[]>('minutas', values);
};

export const postGerarMinuta = (values: IGerarMinuta) => {
  return api.post<IGerarMinutaDocx>('minutas/gerarMinuta', values);
};

export const downloadArquivoMinuta = async (id: any, fileName: any) => {
  const url = '/api/minutas/downloadArquivo';
  await downloadAnexo(id, fileName, url);
};

//#region Item
export const getAllMinutaClausula = () => api.get<IMinutaClausula[]>('minutas/itemClausula');

export const postMinutaItemClausula = (values: IMinutaItemClausulaCreate) => {
  return api.post<IMinuta>('minutas/itemClausula', values);
};

export const postMinutaItemClausulaItemAprovado = (values: IMinutaItemClausulaCreateByItemAprovado) => {
  return api.post<IMinuta>('minutas/itemClausula/aprovado', values);
};

export const putMinutaItemClausula = (values: IMinutaItemClausulaCreate) => {
  return api.put<IMinuta>('minutas/itemClausula/' + values.minutaItemClausulaid, values);
};

export const putStatusMinutaByCodigo = (minutaId: string, codigo: number) => {
  return api.put<IMinuta>('minutas/status/' + minutaId, {
    codigo,
  });
};

export const deleteMinutaItemClausula = (idMinutaItemClausula: string) => {
  return api.delete<IMinuta>('minutas/itemClausula/' + idMinutaItemClausula);
};

export const dragInDropMinutaItemClausula = (values: IDragInDropMinutaItemClausula) =>
  api.post<IMinuta>('minutas/itemClausula/dragInDrop', values, { disableNotification: true });
//#endregion
